const page = require("../../../../../components/page/page");
const accountsPayableDt = require("./accountsPayable-dt");

import accountsPayablePage from "./accountsPayable-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false;

//insert the page  on the body
function HTMLselect(detail) {
  //console.log('accountsPayable init>')

  HTMLwasSelected = true;

  //load the page to the index
  const body = document.body;
  body.insertAdjacentHTML("beforeend", accountsPayablePage);

  accountsPayableDt.start({
    dest: "accountsPayable",
    act: "fecthData",
  });
} /*init*/

/****************ELEMENTS*****************/

export function start(detail) {
  //console.log('accountsPayable page >', detail)

  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  show: {
    start: (detail) => {
      page.start(detail);
    },
  },
}; /**/
